<template>
    <frm-modal-component
        ref="modal"
        class="past-appointment-notification-modal"
        :save-label="t('calendar.past-appointment-notification.suppress')"
        @save="$emit('suppress'); $refs.modal.closeModal()"
    >
        <template #header>
            <frm-icon name="exclamation-mark" />

            {{ t('calendar.past-appointment-notification.title') }}
        </template>

        <p>
            {{ t('calendar.past-appointment-notification.information') }}
        </p>

        <template #buttons>
            <button
                class="button button--dark button--grouped past-appointment-notification-modal__send-button"
                type="button"
                data-testid="past-appointment-notification:send"
                @click="$emit('send'); $refs.modal.closeModal()"
            >
                {{ t('calendar.past-appointment-notification.send') }}
            </button>
        </template>
    </frm-modal-component>
</template>

<script>
import i18n from '../../i18n';

export default {
    methods: {
        t() {
            return i18n.t(...arguments);
        },
    },
};
</script>

<style lang="scss">
.modal__container:has(.past-appointment-notification-modal) {
    overflow: hidden;
}
</style>

<style scoped lang="scss">
.past-appointment-notification-modal {
    ::v-deep .button-group > a.button--text {
        order: 3;
    }
}

.past-appointment-notification-modal__send-button {
    order: 2;
}
</style>
